module.exports = __webpack_public_path__ + "static/ibm-partner-96658164ad6a4d7f966c991418a46f01.png";